import { useEffect, useState, forwardRef } from 'react';
import { useWizard } from 'react-use-wizard';
import styled from 'styled-components';
import tw from 'twin.macro';

import CountDown from '../../count-down';

const WizardHeaderStyled = styled.div`
  ${tw`m-auto flex justify-center mb-5`}
  ul {
    ${tw`flex flex-row`}

    li {
      ${tw`my-3 mx-2 md:my-5 md:mx-5`}
    }
  }

  .step-item-header {
    ${tw`text-white font-bold text-sm text-center self-center md:text-left md:text-xl`}

    &.in-active {
      ${tw`text-opacity-20`}
    }
  }
`;

type WizardHeaderProps = {
  onCountDownExpires?: () => void;
};

const WizardHeader = forwardRef<HTMLDivElement, WizardHeaderProps>(
  ({ onCountDownExpires }: WizardHeaderProps, ref): JSX.Element => {
    const { activeStep, nextStep } = useWizard();
    const [timer, setTimer] = useState(0);

    useEffect(() => {
      if (activeStep === 3) {
        const currentTime = new Date();
        const seconds = 120;
        const currentTimestamp = currentTime.setSeconds(currentTime.getSeconds() + seconds);
        setTimer(currentTimestamp);
      } else {
        setTimer(0);
      }
    }, [activeStep]);
    const onCountDownExpire = async () => {
      await nextStep(1);
      if (onCountDownExpires) {
        onCountDownExpires();
      }
    };
    return (
      <WizardHeaderStyled ref={ref}>
        <ul>
          <li className={`step-item-header ${activeStep === 0 ? 'active' : 'in-active'}`}>
            <div>Pick a Movie</div>
          </li>
          <li className={`step-item-header ${activeStep === 1 ? 'active' : 'in-active'}`}>
            <div>Your Details</div>
          </li>
          <li className={`step-item-header ${activeStep === 2 ? 'active' : 'in-active'}`}>
            <div>Pick a Seat</div>
          </li>
          <li className={`step-item-header ${activeStep === 3 ? 'active' : 'in-active'}`}>
            <div>
              Summary{' '}
              {activeStep >= 3 && timer ? (
                <CountDown expiryTimestamp={timer} onExpire={onCountDownExpire} />
              ) : null}
            </div>
          </li>
        </ul>
      </WizardHeaderStyled>
    );
  },
);

WizardHeader.displayName = 'WizardHeader';
WizardHeader.defaultProps = {
  onCountDownExpires: () => {},
};
export default WizardHeader;
